module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('b', {
    staticStyle: {
      "font-size": "16px",
      "display": "block",
      "margin": "10px 0 0 20px"
    }
  }, [_vm._v("营业执照")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 20px 20px 20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "border-right": "1px solid #e5e5e5"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.yyzzImg) ? _c('el-image', {
    staticStyle: {
      "width": "360px",
      "height": "200px",
      "border-radius": "5px"
    },
    attrs: {
      "src": _vm.yyzzImg,
      "preview-src-list": [_vm.yyzzImg]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('i', {
    staticClass: "el-icon-plus rxghUploader",
    staticStyle: {
      "width": "360px",
      "height": "200px",
      "border-radius": "5px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#222"
    }
  }, [_vm._v("上传要求")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#888"
    }
  }, [_vm._v("1. 请上传清晰的营业执照照片，jpg、png格式均可，文件不超过2MB ； 2. 请确保营业执照边框完整，字迹清晰可见，亮度均匀，文字正向显示；")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#222"
    }
  }, [_vm._v("上传示例")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": require("../../assets/img/yyzz.png")
    }
  })])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主体类型："
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.enterpriseAttribute),
      callback: function($$v) {
        _vm.enterpriseAttribute = $$v
      },
      expression: "enterpriseAttribute"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("个体工商户")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入企业名称",
      "disabled": ""
    },
    model: {
      value: (_vm.qyName),
      callback: function($$v) {
        _vm.qyName = $$v
      },
      expression: "qyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业法人："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入企业法人",
      "disabled": ""
    },
    model: {
      value: (_vm.qyLegal),
      callback: function($$v) {
        _vm.qyLegal = $$v
      },
      expression: "qyLegal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信用代码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入信用代码",
      "disabled": ""
    },
    model: {
      value: (_vm.creditCode),
      callback: function($$v) {
        _vm.creditCode = $$v
      },
      expression: "creditCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期限："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "22%"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "disabled": ""
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _c('span', {
    staticStyle: {
      "margin": "0 8px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "22%"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "disabled": ""
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.longTermOne),
      callback: function($$v) {
        _vm.longTermOne = $$v
      },
      expression: "longTermOne"
    }
  }, [_vm._v("长期有效")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('b', {
    staticStyle: {
      "font-size": "16px",
      "display": "block",
      "margin": "10px 0 0 20px"
    }
  }, [_vm._v("法人身份证(选填)")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "0 20px 20px 20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "border-right": "1px solid #e5e5e5"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "rxgh"
  }, [_c('div', {
    staticClass: "rxghDiv"
  }, [(_vm.rxLong) ? _c('el-image', {
    staticClass: "rxghAvatarImg",
    attrs: {
      "src": _vm.rxLong,
      "preview-src-list": [_vm.rxLong]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 1); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus rxghUploader"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rxLong),
      expression: "rxLong"
    }],
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(1)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rxghSM"
  }, [_vm._v(" 法人或经营者身份证正面（人像） ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rxghDiv"
  }, [(_vm.ghLong) ? _c('el-image', {
    staticClass: "rxghAvatarImg",
    attrs: {
      "src": _vm.ghLong,
      "preview-src-list": [_vm.ghLong]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 2); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus rxghUploader"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ghLong),
      expression: "ghLong"
    }],
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(2)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rxghSM"
  }, [_vm._v(" 法人或经营者身份证反面（国徽） ")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#222"
    }
  }, [_vm._v("上传要求")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#888"
    }
  }, [_vm._v("1. 请上传清晰的法人身份证照片，jpg、png格式均可，文件不超过2MB ； 2. 请确保身份证边框完整，字迹清晰可见，亮度均匀，文字正向显示；")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#222"
    }
  }, [_vm._v("上传示例")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": require("../../assets/img/sfz.png")
    }
  })])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "21",
      "placeholder": "请输入法人姓名"
    },
    model: {
      value: (_vm.sfzxm),
      callback: function($$v) {
        _vm.sfzxm = $$v
      },
      expression: "sfzxm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "21",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.sfzhm),
      callback: function($$v) {
        _vm.sfzhm = $$v
      },
      expression: "sfzhm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "居住地址："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "200",
      "placeholder": "请输入居住地址"
    },
    model: {
      value: (_vm.jzdz),
      callback: function($$v) {
        _vm.jzdz = $$v
      },
      expression: "jzdz"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期限："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "22%"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.ksTime),
      callback: function($$v) {
        _vm.ksTime = $$v
      },
      expression: "ksTime"
    }
  }), _c('span', {
    staticStyle: {
      "margin": "0 8px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "22%"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "disabled": _vm.longTermTwo
    },
    model: {
      value: (_vm.jsTime),
      callback: function($$v) {
        _vm.jsTime = $$v
      },
      expression: "jsTime"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    model: {
      value: (_vm.longTermTwo),
      callback: function($$v) {
        _vm.longTermTwo = $$v
      },
      expression: "longTermTwo"
    }
  }, [_vm._v("长期有效")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发证机关："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "21",
      "placeholder": "请输入发证机关"
    },
    model: {
      value: (_vm.fzjg),
      callback: function($$v) {
        _vm.fzjg = $$v
      },
      expression: "fzjg"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('b', {
    staticStyle: {
      "font-size": "16px",
      "display": "block",
      "margin": "10px 0 0 20px"
    }
  }, [_vm._v("入驻信息")]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    },
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经营区域："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.jyqyOptions,
      "filterable": "",
      "clearable": "",
      "disabled": ""
    },
    on: {
      "change": _vm.handlejyqy
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入驻时间："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入",
      "disabled": ""
    },
    model: {
      value: (_vm.joinTime),
      callback: function($$v) {
        _vm.joinTime = $$v
      },
      expression: "joinTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入联系人姓名",
      "disabled": ""
    },
    model: {
      value: (_vm.linkman),
      callback: function($$v) {
        _vm.linkman = $$v
      },
      expression: "linkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入联系手机号",
      "disabled": ""
    },
    model: {
      value: (_vm.linkphone),
      callback: function($$v) {
        _vm.linkphone = $$v
      },
      expression: "linkphone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业介绍："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入企业介绍，最多输入500个字",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "show-word-limit": "",
      "maxlength": "500"
    },
    model: {
      value: (_vm.addressDetail),
      callback: function($$v) {
        _vm.addressDetail = $$v
      },
      expression: "addressDetail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('b', {
    staticStyle: {
      "font-size": "16px",
      "display": "block",
      "margin": "10px 0 0 20px"
    }
  }, [_vm._v("资质证书")]), _vm._v(" "), _c('div', {
    staticClass: "upPictures"
  }, [_vm._l((_vm.zzzsImg), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "multigraph",
      attrs: {
        "data-img": item
      }
    }, [_c('el-image', {
      staticClass: "seeLarge",
      attrs: {
        "src": item,
        "fit": "cover",
        "preview-src-list": _vm.zzzsImg
      },
      on: {
        "click": _vm.handleClickItem
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delZzzs(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      }
    })])], 1)
  }), _vm._v(" "), (_vm.zzzsFlag < 15) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "before-upload": _vm.beforeUploadZzzs,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus upBtn"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "spPicWenan"
  }, [_vm._v("请上传资质证书或荣誉整数,支持JPG,PNG格式，单张图片最大5MB，最多上传15张")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "main_container",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "16px",
      "display": "block",
      "margin": "10px 0 0 20px"
    }
  }, [_vm._v("旗下店铺")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "98%",
      "margin": "10px auto"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.subsidiaryStoresList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "线下店名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "管理者",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "管理者手机号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺管理员",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.staffCount))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总成交额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.profit))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "详细地址",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.address))]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.totalRowsCount
    },
    on: {
      "current-change": _vm.handleCurrent
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handleGive()
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请选择企业",
      "visible": _vm.dialogSksz,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSksz = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "企业名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择企业"
    },
    on: {
      "change": _vm.handleChangeQymc
    },
    model: {
      value: (_vm.enterpriseId),
      callback: function($$v) {
        _vm.enterpriseId = $$v
      },
      expression: "enterpriseId"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-477cae26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/enterpriseinfo.vue
// module id = 1682
// module chunks = 3